import img from "../../images/commentcamarche/image_heure.gif";
const AdvanceTabPage = () => {
  return (
    <>
      <div className="max-w-full mx-auto font-sans rbt-advance-tab-area dark:bg-neutral-800 ">
        {/* <AdvanceTab tag="YOU CAN CUSTOMIZE ALL" title="Et que l’aventure commence ! " /> */}

        <h2 className="mt-20 mb-20 text-2xl font-bold text-center text-gray-800 sm:text-3xl lg:text-4xl dark:text-white">
          Réservez à l’heure, à la journée ou pour une soirée — selon vos envies
        </h2>
        <div className="flex justify-center ">
          <img src={img} alt="" className="w-1/2 mx-auto" />
        </div>
      </div>
    </>
  );
};

export default AdvanceTabPage;
